module.exports = __webpack_public_path__ + "static/media/2.1097da7f.jpeg";